import vmClient from 'app/services/vmClient';
import { Entity, IEntityType, IEntity, EntityStringId } from 'app/types/entity';
import { CommonText, ICommonText } from 'app/constants/schemas/CommonText';
import { Issue, IIssue } from 'app/constants/schemas/Issue';
import { Section, ISection } from 'app/constants/schemas/Section';
import { Text, IText } from 'app/constants/schemas/Text';

export interface IExercise extends IEntity {
  attributes: {
    id: EntityStringId;
    cohortId: string | null;
    exerciseType: string;
  };
  associations: {
    commonTitleText: ICommonText | null;
    customTitleText: IText | null;
    commonIntroductionText: ICommonText | null;
    customIntroductionText: IText | null;
    commonTeacherNoteText: ICommonText | null;
    customTeacherNoteText: IText | null;
    issues: IIssue[];
    sections: ISection[];
  };
}

export type Exercise = Entity<IExercise>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Exercise: IEntityType<IExercise> = vmClient.defineClass({
  typeName: 'Exercise',
  version: 4,
  lockable: true,
  persisted: true,
  attributes: {
    cohortId: 'string',
    exerciseType: {
      type: 'string',
      notNull: true,
    },
  },
  associations: {
    commonTitleText: {
      type: CommonText,
      shared: true,
    },
    customTitleText: Text,
    commonIntroductionText: {
      type: CommonText,
      shared: true,
    },
    customIntroductionText: Text,
    commonTeacherNoteText: {
      type: CommonText,
      shared: true,
    },
    customTeacherNoteText: Text,
    issues: [Issue],
    sections: [Section],
  },
});
